
	[...document.querySelectorAll( '.js-slide-down' )].forEach( item => {
		const inner = item.querySelector( '.js-slide-down-inner' );

		if ( inner ) {
			item.style.height = '0px';
			item.classList.add( 'transition-height' );
			setTimeout( () => {
				item.style.height = `${inner.offsetHeight}px`;
				setTimeout( () => {
					item.style.height = 'auto';
				}, 500 )
			}, 500 )
		}
	} );